module.exports = __webpack_public_path__ + "media/images/talent/case03-illust-8eef531bc24a46f413a08e4d32f94e2a.png";